import { PAGE_SIZE } from "@faire/retailer-shared/search/searchRequest";

export const getPageSize = (replacedProductTilesCount: number) =>
  PAGE_SIZE - replacedProductTilesCount;
export const getShouldWaitForBannersQuery = (
  zeroIndexedPageNumber: number,
  isBannersQueryLoading: boolean
) => zeroIndexedPageNumber > 0 && isBannersQueryLoading;

const FROZEN_EMPTY_ARRAY: ReadonlyArray<never> = Object.freeze([]);
export function noOpReturningArrayOfType<T>() {
  return FROZEN_EMPTY_ARRAY as unknown as Array<T>;
}
